export const STORAGE = {
  accessToken: 'access_token',
  idToken: 'id_token',
  refreshToken: 'refresh_token',
  idTokenClaimsObj: 'id_token_claims_obj',
};
